/* ==========================================================================
   CLARITY CLUB-LEITER — Belohnungsstufen im Abo. 23.08.2026 21:30

   Marcus: "Geschenk nach der 4. Lieferung ... eines unserer Kapselprodukte
   zur Auswahl" + "wie bei Revolut RevPoints, ab 100 Points gibts 10 Euro"
   + "cool waere das dann im ABO bereich zu sehen wie bei Miles and More"

   🔑 LOOP KANN DAS BEREITS — Flow-Typ "Reward Journey": Meilenstein-Belohnungen
   nach Anzahl Lieferungen, inklusive Fortschrittsbanner im Kundenportal.
   Eine zweite Loyalty-App ist dafuer NICHT noetig.
   Was Loop NICHT kann: die Leiter VOR dem Kauf zeigen. Genau das macht diese
   Datei — sie macht die Bindung zum Verkaufsargument statt zur Ueberraschung.

   🔴 AKTIV = false, SOLANGE LOOP NICHT EINGERICHTET IST.
   Eine sichtbare Belohnungsleiter ohne Einloesung ist ein Versprechen, das
   nicht gehalten wird (§ 5 UWG). Erst in Loop unter Flows > Reward Journey
   anlegen, dann hier auf true stellen.

   🔑 WARUM STUFE 1 SCHON NACH 2 LIEFERUNGEN
   Abonnenten kuendigen frueh. Bei 8,88 % Churn leben nach 6 Monaten noch 57 %
   der Kohorte, nach 12 Monaten nur noch 33 %. Eine Belohnung nach 12 Monaten
   erreicht ein Drittel der Kunden. Eine nach 2 Lieferungen erreicht die, die
   noch wackeln — und genau dort wirkt sie.

   💶 WAS DIE LEITER KOSTET (Wareneinsatz + Gutschrift ueber 8 Lieferungen)
   30,94 EUR — das sind 2,3 % beim Matcha-3-Monats-Abo, 3,1 % bei PURE 3 Monate,
   8,6 % beim 1-Monats-Abo. Rechnet sich, sobald der Churn um rund 1 Punkt faellt.

   🔴 PUNKTE VS. GESCHENK — gerechnet am 23.08.
   Ein RevPoints-Modell mit 1 Punkt je EUR waere 10 % Rueckverguetung und damit
   20 % des Deckungsbeitrags. Bei 0,3 Punkten je EUR sind es 3 %. Das Geschenk
   nach fester Lieferzahl ist bei allen 3-Monats-Plaenen guenstiger als Punkte,
   weil Punkte laufend auf JEDEN Umsatz anfallen. Deshalb: Stufen, keine Waehrung.
   ========================================================================== */
window.CLARITY_CLUB_LEITER = {

  /* 🔴 Erst auf true stellen, wenn die Reward Journey in Loop steht. */
  aktiv: false,

  titel: "Deine Club-Leiter",
  hinweis: "Je länger du dabei bist, desto mehr bekommst du zurück. Deinen Stand siehst du jederzeit in deinem Konto.",

  stufen: [
    {
      nach: 2,
      name: "Erste Stufe",
      belohnung: "Ein Kapselprodukt deiner Wahl",
      detail: "Skin Activator oder Collagen Complex+ — gratis dazu."
    },
    {
      nach: 4,
      name: "Zweite Stufe",
      belohnung: "10 € Guthaben",
      detail: "Wird automatisch auf deine nächste Lieferung angerechnet."
    },
    {
      nach: 8,
      name: "Dritte Stufe",
      belohnung: "Noch ein Kapselprodukt",
      detail: "Freie Wahl aus dem Sortiment — für alle, die dabeigeblieben sind."
    }
  ]
};